import {
  GuestLiteModel,
  GuestModel,
  getGuestKey,
  getGuestsKey,
  useGetGuest,
  useGetGuests,
} from 'api-hooks/guest';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import { capitalize, transformLabel } from 'common/utils/string';
import { ColumnDataType } from 'components/elements/table/type';
import React from 'react';

import useGetCrudPermission from './use-get-crud-permission';
import useNavigation from './use-navigation';

export function guestTransformer(item: GuestLiteModel | GuestModel): Option {
  const name = transformLabel(
    [item.title && capitalize(item.title), item.name],
    ' ',
  );
  return {
    id: item.id,
    label: transformLabel([name, item.alias]),
    extra: item,
  };
}

export default function useGetGuestColumn() {
  const permission = useGetCrudPermission('guests');
  const { navigate } = useNavigation();

  return React.useMemo(() => {
    return {
      dataType: ColumnDataType.select,
      useListQueryHook: useGetGuests,
      useDetailLazyQueryHook: useGetGuest,
      listKeyFunction: getGuestsKey,
      detailKeyFunction: getGuestKey,
      getMemoizedListVariables: (page, q) => ({
        params: {
          q,
          page,
        },
      }),
      getMemoizedDetailVariables: (value: string) => ({
        id: value,
      }),
      listTransformer: (result) => {
        return result.data.map((v) => {
          const data = ModelTransformer(v, GuestLiteModel);
          return guestTransformer(data);
        });
      },
      detailTransformer: (result) => {
        const data = ModelTransformer(result.data, GuestModel);
        return guestTransformer(data);
      },
      paginationTransformer: (result) => {
        return result.meta;
      },
      filterOptions: null,

      renderCreate: permission.create,
      onClickCreate: () => {
        navigate(NavigationRoutes.GuestsCreate);
      },
    };
  }, [navigate, permission.create]);
}
